"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolsIds = exports.tools = void 0;
exports.tools = {
    player: {
        id: 'player',
        group: 'visualizations',
        options: {
            id: false,
            speed: false,
            size: 1.0,
            color: '#000000',
            boxPositionDown: false,
            spotlight: false,
            spotlightSize: 0.5,
            spotlightColor: '#ffffff',
            spotlightOpacity: 0.43,
            spotlightHeight: 2.0,
            ringSize: 0.73,
            ringBorder: false,
            ringBorderColor: '#ffffff',
            ringFill: false,
            ringFillColor: '#dc3322',
            is3d: false
        },
        limits: {
            size: { min: 0.2, max: 2.5 },
            spotlightOpacity: { min: 0.1, max: 1.0 },
            spotlightHeight: { min: 0.1, max: 10.0 },
            spotlightSize: { min: 0.2, max: 4.0 },
            ringSize: { min: 0.5, max: 4.0 }
        },
        defaults: ['size', 'spotlightOpacity', 'spotlightSize', 'ringSize']
    },
    magnifier: {
        id: 'magnifier',
        group: 'visualizations',
        options: {
            color: '#ffffff',
            zoom: 0.83,
            size: 0.71
        },
        limits: {
            zoom: { min: 0.2, max: 1.5 },
            size: { min: 0.5, max: 1.5 }
        },
        defaults: []
    },
    measurer: {
        id: 'measurer',
        group: 'visualizations',
        options: {
            borderColor: '#dc3322',
            borderEdgeOpacity: 0.4,
            borderOpacity: 0.9,
            closed: false,
            continuous: true,
            dashSize: 1.45,
            distance: true,
            distanceColor: '#ffffff',
            distanceIs3d: false,
            distancePosition: 0.92,
            distanceOpacity: 1.0,
            distanceSize: 1.01,
            dotted: false,
            fillColor: '#dc3322',
            fillOpacity: 0.42,
            fillSolid: true,
            fillStripes: false,
            fillSquares: false,
            fillSize: 1.0,
            fillRotation: Math.PI * 0.9,
            is3d: false,
            ringBorder: true,
            ringBorderColor: '#ffffff',
            ringFill: true,
            ringFillColor: '#dc3322',
            ringSize: 0.91,
            thickness: 0.13,
            width: 0.23
        },
        limits: {
            borderEdgeOpacity: { min: 0.0, max: 1.0 },
            borderOpacity: { min: 0.0, max: 1.0 },
            fillOpacity: { min: 0.0, max: 1.0 },
            fillSize: { min: 0.5, max: 2.0 },
            fillRotation: { min: -Math.PI, max: Math.PI },
            width: { min: 0.15, max: 2.0 },
            thickness: { min: 0.0, max: 5.0 },
            dashSize: { min: 0.2, max: 2.5 },
            ringSize: { min: 0.6, max: 4.0 },
            distancePosition: { min: 0.5, max: 2.0 },
            distanceOpacity: { min: 0.0, max: 1.0 },
            distanceSize: { min: 0.5, max: 1.5 }
        },
        defaults: [
            'borderEdgeOpacity',
            'borderOpacity',
            'fillRotation',
            'width',
            'thickness',
            'dashSize',
            'distancePosition',
            'distanceOpacity',
            'distanceSize',
            'ringSize'
        ]
    },
    trail: {
        id: 'trail',
        group: 'visualizations',
        options: {
            color: '#0062ad',
            continuous: true,
            dotted: false,
            dashSize: 1.0,
            is3d: false,
            ringBorder: true,
            offsetOpacity: 0.26,
            opacity: 1.0,
            ringBorderColor: '#ffffff',
            ringFill: true,
            ringFillColor: '#009cdd',
            ringSize: 1.0,
            seconds: 5.0,
            thickness: 0.1,
            width: 0.24
        },
        limits: {
            seconds: { min: 1.0, max: 99.0 },
            width: { min: 0.1, max: 2.0 },
            thickness: { min: 0.1, max: 5.0 },
            offsetOpacity: { min: 0.0, max: 1.0 },
            opacity: { min: 0.0, max: 1.0 },
            dashSize: { min: 0.2, max: 2.5 },
            ringSize: { min: 0.6, max: 4.0 }
        },
        defaults: ['width', 'opacity', 'thickness', 'dashSize']
    },
    futureTrail: {
        id: 'futureTrail',
        group: 'visualizations',
        options: {
            color: '#ff9e2d',
            continuous: true,
            dashSize: 0.6,
            dotted: false,
            is3d: false,
            offsetOpacity: 0.05,
            opacity: 1.0,
            ringBorder: true,
            ringBorderColor: '#ffffff',
            ringFill: true,
            ringFillColor: '#ffdc3a',
            ringSize: 1.0,
            seconds: 5.0,
            thickness: 0.23,
            width: 0.29
        },
        limits: {
            seconds: { min: 1.0, max: 99.0 },
            width: { min: 0.1, max: 2.0 },
            thickness: { min: 0.1, max: 5.0 },
            offsetOpacity: { min: 0.0, max: 1.0 },
            opacity: { min: 0.0, max: 1.0 },
            dashSize: { min: 0.2, max: 2.5 },
            ringSize: { min: 0.6, max: 4.0 }
        },
        defaults: ['width', 'opacity', 'thickness', 'dashSize']
    },
    teamSize: {
        id: 'teamSize',
        group: 'visualizations',
        options: {
            teamId: '',
            line: '',
            continuous: true,
            dotted: false,
            color: '#683391',
            x: 0.0,
            y: 0.0,
            width: 0.23,
            edgeOpacity: 0.0,
            opacity: 1.0,
            thickness: 0.22,
            dashSize: 0.6,
            distance: true,
            distanceColor: '#ffffff',
            distancePosition: 1.12,
            distanceOpacity: 1.0,
            distanceSize: 1.3,
            distanceIs3d: false,
            is3d: false
        },
        limits: {
            width: { min: 0.1, max: 5.0 },
            edgeOpacity: { min: 0.0, max: 1.0 },
            opacity: { min: 0.0, max: 1.0 },
            thickness: { min: 0.0, max: 5.0 },
            dashSize: { min: 0.2, max: 2.5 },
            distancePosition: { min: 0.5, max: 2.0 },
            distanceOpacity: { min: 0.0, max: 1.0 },
            distanceSize: { min: 0.5, max: 1.5 }
        },
        defaults: [
            'width',
            'edgeOpacity',
            'opacity',
            'thickness',
            'dashSize',
            'distanceOpacity',
            'distancePosition',
            'distanceSize'
        ]
    },
    tacticalLines: {
        id: 'tacticalLines',
        group: 'visualizations',
        options: {
            teamId: '',
            line: '',
            borderColor: '#ffffff',
            borderEdgeOpacity: 0.3,
            borderOpacity: 1.0,
            fillColor: '#ffffff',
            fillOpacity: 0.4,
            fillSolid: true,
            fillStripes: false,
            fillSquares: false,
            fillSize: 1.0,
            fillRotation: Math.PI * 0.9,
            closed: false,
            width: 0.23,
            thickness: 0.3,
            dashSize: 1.0,
            continuous: true,
            dotted: false,
            is3d: false,
            ringBorder: true,
            ringBorderColor: '#ffffff',
            ringFill: true,
            ringFillColor: '#ffffff',
            ringSize: 0.6,
            distance: true,
            distanceColor: '#ffffff',
            distancePosition: 0.5,
            distanceOpacity: 1.0,
            distanceSize: 0.73,
            distanceIs3d: false
        },
        limits: {
            borderEdgeOpacity: { min: 0.1, max: 1.0 },
            borderOpacity: { min: 0.0, max: 1.0 },
            fillOpacity: { min: 0.0, max: 1.0 },
            fillSize: { min: 0.5, max: 2.0 },
            fillRotation: { min: -Math.PI, max: Math.PI },
            width: { min: 0.1, max: 2.0 },
            thickness: { min: 0.0, max: 5.0 },
            dashSize: { min: 0.2, max: 2.5 },
            ringSize: { min: 0.6, max: 4.0 },
            distancePosition: { min: 0.5, max: 2.0 },
            distanceOpacity: { min: 0.0, max: 1.0 },
            distanceSize: { min: 0.5, max: 1.5 }
        },
        defaults: [
            'borderEdgeOpacity',
            'borderOpacity',
            'fillRotation',
            'width',
            'thickness',
            'dashSize',
            'ringSize',
            'distanceOpacity',
            'distancePosition',
            'distanceSize'
        ]
    },
    line3d: {
        id: 'line3d',
        group: 'drawings',
        options: {
            arrowheadWidth: 1.5,
            color: '#ff4f43',
            continuous: true,
            curvature: 0.0,
            dashSize: 0.4,
            distance: false,
            distanceColor: '#ffffff',
            distancePosition: 0.92,
            distanceOpacity: 1.0,
            distanceSize: 1.01,
            distanceIs3d: false,
            dotted: false,
            dynamic: false,
            edgeOpacity: 0.2,
            opacity: 0.9,
            height: 0.075,
            heightCenter: 0.0,
            is3d: false,
            pinned: false,
            thickness: 0.15,
            width: 0.5
        },
        limits: {
            width: { min: 0.1, max: 5.0 },
            thickness: { min: 0.0, max: 5.0 },
            curvature: { min: -1.0, max: 1.0 },
            height: { min: 0.0, max: 0.15 },
            heightCenter: { min: -1.0, max: 1.0 },
            arrowheadWidth: { min: 0.99, max: 2.0 },
            edgeOpacity: { min: 0.0, max: 1.0 },
            opacity: { min: 0.0, max: 1.0 },
            dashSize: { min: 0.2, max: 2.5 },
            distancePosition: { min: 0.5, max: 2.0 },
            distanceOpacity: { min: 0.0, max: 1.0 },
            distanceSize: { min: 0.5, max: 4.0 }
        },
        defaults: [
            'width',
            'thickness',
            'curvature',
            'heightCenter',
            'edgeOpacity',
            'opacity',
            'dashSize',
            'distanceOpacity',
            'distancePosition',
            'distanceSize'
        ]
    },
    freehand: {
        id: 'freehand',
        group: 'drawings',
        options: {
            color: '#9edd34',
            arrowheadWidth: 3.0,
            continuous: true,
            dashSize: 0.5,
            dotted: false,
            offsetOpacity: 0.2,
            opacity: 0.9,
            is3d: false,
            pinned: false,
            thickness: 0.07,
            width: 0.2
        },
        limits: {
            arrowheadWidth: { min: 0.99, max: 5.0 },
            dashSize: { min: 0.2, max: 2.0 },
            offsetOpacity: { min: 0.0, max: 1.0 },
            opacity: { min: 0.0, max: 1.0 },
            thickness: { min: 0.0, max: 5.0 },
            width: { min: 0.1, max: 2.0 }
        },
        defaults: ['opacity', 'width', 'thickness', 'dashSize', 'arrowheadWidth']
    },
    circle: {
        id: 'circle',
        group: 'drawings',
        options: {
            borderColor: '#b3b3b3',
            borderOpacity: 1.0,
            fillColor: '#ffdc3a',
            fillOpacity: 0.26,
            fillSolid: true,
            fillStripes: false,
            fillSize: 1.0,
            fillRotation: Math.PI * 0.9,
            is3d: false,
            pinned: false,
            thickness: 0.5,
            width: 0.62
        },
        limits: {
            borderOpacity: { min: 0.0, max: 1.0 },
            fillOpacity: { min: 0.0, max: 1.0 },
            fillSize: { min: 0.5, max: 2.0 },
            fillRotation: { min: -Math.PI, max: Math.PI },
            thickness: { min: 0.0, max: 5.0 },
            width: { min: 0.0, max: 3.0 }
        },
        defaults: ['borderOpacity', 'fillOpacity', 'thickness']
    },
    shape: {
        id: 'shape',
        group: 'drawings',
        options: {
            borderColor: '#0062ad',
            borderOpacity: 1.0,
            borderContinuous: false,
            borderDotted: true,
            closed: false,
            dashSize: 0.6,
            distance: true,
            distanceColor: '#ffffff',
            distancePosition: 1.0,
            distanceOpacity: 1.0,
            distanceSize: 1.0,
            distanceIs3d: false,
            fillColor: '#0062ad',
            fillOpacity: 0.25,
            fillSolid: true,
            fillStripes: false,
            fillSquares: false,
            fillSize: 1.0,
            fillRotation: Math.PI * 0.9,
            is3d: false,
            pinned: false,
            thickness: 0.1,
            width: 0.15
        },
        limits: {
            borderOpacity: { min: 0.1, max: 1.0 },
            dashSize: { min: 0.2, max: 2.5 },
            distancePosition: { min: 0.5, max: 2.0 },
            distanceOpacity: { min: 0.0, max: 1.0 },
            distanceSize: { min: 0.5, max: 1.5 },
            fillOpacity: { min: 0.0, max: 1.0 },
            fillSize: { min: 0.5, max: 2.0 },
            fillRotation: { min: -Math.PI, max: Math.PI },
            thickness: { min: 0.0, max: 5.0 },
            width: { min: 0.0, max: 2.0 }
        },
        defaults: [
            'borderOpacity',
            'dashSize',
            'fillOpacity',
            'fillRotation',
            'thickness',
            'width',
            'distancePosition',
            'distanceOpacity',
            'distanceSize'
        ]
    },
    arrow: {
        id: 'arrow',
        group: 'drawings',
        options: {
            arrowheadWidth: 1.5,
            color: '#ff4f43',
            continuous: true,
            curvature: 0.0,
            dashSize: 0.4,
            distance: false,
            distanceColor: '#ffffff',
            distancePosition: 0.92,
            distanceOpacity: 1.0,
            distanceSize: 1.01,
            distanceIs3d: false,
            dotted: false,
            dynamic: false,
            edgeOpacity: 0.2,
            opacity: 0.9,
            height: 0.0,
            heightCenter: 0.0,
            is3d: false,
            pinned: false,
            thickness: 0.15,
            width: 0.5
        },
        limits: {
            width: { min: 0.1, max: 5.0 },
            thickness: { min: 0.0, max: 5.0 },
            curvature: { min: -1.0, max: 1.0 },
            height: { min: 0.0, max: 0.15 },
            heightCenter: { min: -1.0, max: 1.0 },
            arrowheadWidth: { min: 0.99, max: 2.0 },
            edgeOpacity: { min: 0.0, max: 1.0 },
            opacity: { min: 0.0, max: 1.0 },
            dashSize: { min: 0.2, max: 2.5 },
            distancePosition: { min: 0.5, max: 2.0 },
            distanceOpacity: { min: 0.0, max: 1.0 },
            distanceSize: { min: 0.5, max: 4.0 }
        },
        defaults: [
            'width',
            'thickness',
            'curvature',
            'heightCenter',
            'edgeOpacity',
            'opacity',
            'dashSize',
            'distanceOpacity',
            'distancePosition',
            'distanceSize'
        ]
    },
    dragger: {
        id: 'dragger',
        group: 'drawings',
        options: {
            arrowColor: '#ffdc3a',
            arrowContinuous: true,
            arrowDashSize: 0.6,
            arrowDotted: false,
            arrowDynamic: false,
            arrowheadWidth: 2.0,
            arrowEdgeOpacity: 0.2,
            arrowOpacity: 0.9,
            arrowOffsetY: 0.46,
            arrowThickness: 0.23,
            arrowWidth: 0.65,
            distance: false,
            distanceColor: '#ffffff',
            distanceIs3d: false,
            distancePosition: 1.0,
            distanceOpacity: 1.0,
            distanceSize: 1.0,
            fade: 0.5,
            is3d: false,
            opacity: 0.4,
            scale: 1.0,
            size: 1.0,
            smoothing: 0.05,
            threshold: 0.2
        },
        limits: {
            arrowOffsetY: { min: -1.0, max: 1.0 },
            arrowEdgeOpacity: { min: 0.0, max: 1.0 },
            arrowOpacity: { min: 0.0, max: 1.0 },
            arrowheadWidth: { min: 0.0, max: 2.0 },
            arrowWidth: { min: 0.2, max: 5.0 },
            arrowThickness: { min: 0.0, max: 5.0 },
            arrowDashSize: { min: 0.6, max: 2.5 },
            distancePosition: { min: 0.5, max: 2.0 },
            distanceOpacity: { min: 0.0, max: 1.0 },
            distanceSize: { min: 0.5, max: 4.0 },
            threshold: { min: 0.0, max: 1.0 },
            smoothing: { min: 0.0, max: 1.0 },
            fade: { min: 0.1, max: 1.0 },
            opacity: { min: 0.0, max: 1.0 },
            scale: { min: 0.2, max: 2.0 },
            size: { min: 0.5, max: 4.0 }
        },
        defaults: [
            'arrowDashSize',
            'arrowEdgeOpacity',
            'arrowOpacity',
            'arrowOffsetY',
            'arrowThickness',
            'arrowWidth',
            'distanceOpacity',
            'distanceSize',
            'distancePosition',
            'threshold'
        ]
    },
    pause: {
        id: 'pause',
        group: 'drawings'
    },
    keyframing: {
        id: 'keyframing',
        group: 'keyframing'
    },
    textBox: {
        id: 'textBox',
        group: 'annotation',
        options: {
            text: 'Insert Text',
            x: 0.45,
            y: 0.45,
            width: 0.1,
            height: 0.1,
            size: 1.0,
            rotation: 0.0,
            color: '#ffffff',
            opacity: 1.0,
            align: 'center',
            background: false,
            backgroundColor: '#000000',
            backgroundOpacity: 0.5,
            is3d: false
        },
        limits: {
            size: { min: 0.5, max: 4.0 },
            rotation: { min: -Math.PI, max: Math.PI },
            opacity: { min: 0.0, max: 1.0 },
            backgroundOpacity: { min: 0.0, max: 1.0 }
        },
        defaults: ['opacity', 'rotation']
    },
    image: {
        id: 'image',
        group: 'annotation',
        options: {
            x: 0.25,
            y: 0.25,
            scaleX: 1.0,
            scaleY: 1.0,
            rotation: 0.0,
            opacity: 1.0,
            is3d: false
        },
        limits: {
            rotation: { min: -Math.PI, max: Math.PI },
            opacity: { min: 0.0, max: 1.0 }
        },
        defaults: ['opacity', 'rotation']
    },
    chromaKey: {
        id: 'chromaKey',
        group: 'annotation',
        options: {
            threshold: 0.01,
            smoothing: 0.1,
            colors: []
        },
        limits: {
            threshold: { min: 0.0, max: 1.0 },
            smoothing: { min: 0.0, max: 1.0 }
        },
        defaults: []
    },
    surface: {
        id: 'surface',
        group: 'annotation',
        options: {
            startColor: '#ff0000',
            middleColor: '#ffffff',
            endColor: '#0000ff',
            startOpacity: 1.0,
            middleOpacity: 1.0,
            endOpacity: 1.0,
            threeColors: true,
            center: 0.5,
            gradient: 0.5,
            opacity: 0.5,
            width: 0.5
        },
        limits: {
            startOpacity: { min: 0.0, max: 1.0 },
            middleOpacity: { min: 0.0, max: 1.0 },
            endOpacity: { min: 0.0, max: 1.0 },
            center: { min: 0.0, max: 1.0 },
            gradient: { min: 0.0, max: 1.0 },
            opacity: { min: 0.0, max: 1.0 },
            width: { min: 0.0, max: 0.5 }
        },
        defaults: ['startOpacity', 'middleOpacity', 'endOpacity', 'opacity', 'center', 'gradient']
    },
    tooltip: {
        id: 'tooltip',
        group: 'tooltip'
    }
};
exports.toolsIds = Object.keys(exports.tools).map(key => key);
